// import * as m from 'mithril';

let parentPage = 'unknown';

const fbq = Object.hasOwn(window, 'fbq') ? window['fbq'] : () => { console.warn('fbq is not defined')};

function trackingCallback(el) {
    const targetLink: HTMLElement = el.currentTarget;
    let linkType = 'unknown';
    if (targetLink.dataset.type && targetLink.dataset.type.length > 1) {
        linkType = `click${targetLink.dataset.type.charAt(0).toUpperCase()}${targetLink.dataset.type.slice(1)}`;
    }
    const linkTarget = targetLink.dataset.target;
    fbq('trackCustom', linkType, {target: linkTarget, parentPage});
    // console.warn(`### ${linkType}: ${parentPage}-${linkTarget}`);
}


export function setTrackingEvents(querySelector: string, parent) {
    parentPage = parent;
    // console.warn(`### container: ${container}`);
    // const route = m.route.get();
    // let parent = 'unknown';
    // if (route) {
    //     if (route.length > 1) parent = route.slice(1);
    //     else parent = 'home'
    // }

    // const trackingCallback = (el) => {
    //     const targetLink: HTMLElement = el.currentTarget;
    //     let linkType = 'unknown';
    //     if (targetLink.dataset.type && targetLink.dataset.type.length > 1) {
    //         linkType = `click${targetLink.dataset.type.charAt(0).toUpperCase()}${targetLink.dataset.type.slice(1)}`;
    //     }
    //     const linkTarget = targetLink.dataset.target;
    //     fbq('trackCustom', linkType, {target: linkTarget, parent});
    //     console.warn(`### ${linkType}: ${parent}-${linkTarget}`);
    // }

    document.querySelectorAll(querySelector).forEach((targetLink: HTMLElement) => {
        // let linkType = 'unknown';
        // if (targetLink.dataset.type && targetLink.dataset.type.length > 1) {
        //     linkType = `click${targetLink.dataset.type.charAt(0).toUpperCase()}${targetLink.dataset.type.slice(1)}`;
        // }
        // const linkTarget = targetLink.dataset.target;

        // targetLink.removeEventListener('click', trackingCallback);
        targetLink.addEventListener('click', trackingCallback);
        // targetLink.addEventListener('click', () => {
        //     fbq('trackCustom', linkType, {target: linkTarget, parent});
        //     console.warn(`### ${linkType}: ${parent}-${linkTarget}`);
        // })
    });
}

export function clearTrackingEvents(querySelector: string) {
    document.querySelectorAll(querySelector).forEach((targetLink: HTMLElement) => {
        targetLink.removeEventListener('click', trackingCallback);
    });
}